import { cn } from '@/lib/utils';
import { Document } from '@contentful/rich-text-types';
import { HTMLAttributes } from 'react';
import RichTextViewer from '../rich-text-viewer/rich-text-viewer';

import { Entry } from 'contentful';
import { TypeSectionBackgroundSkeleton } from 'types/contentful/TypeSectionBackground';
import styles from './step.module.scss';

export type StepTypes = {
  index: number;
  heading: string;
  description?: Document;
  backgroundVariant?: Entry<
    TypeSectionBackgroundSkeleton,
    'WITHOUT_UNRESOLVABLE_LINKS',
    string
  >['fields']['variant'];
};

export const Step = ({
  index,
  heading,
  description,
  className,
  backgroundVariant = 'white',
  ...props
}: StepTypes & HTMLAttributes<HTMLDivElement>) => {
  // Calculate the background variant using modulo (1-4)
  const headerBackgroundVariant = (index % 4) + 1;

  return (
    <div className={cn(styles.component, className)} {...props}>
      <div
        className={cn(
          styles.component_number,
          styles[`component_number-${headerBackgroundVariant}`],
        )}
      >
        STEP {index + 1}
      </div>
      <div
        className={cn(styles.component_container, styles[`component--${backgroundVariant}_card`])}
      >
        <p className={styles.component_heading}>{heading}</p>
        <div className={styles.component_description}>
          <RichTextViewer content={description} />
        </div>
      </div>
    </div>
  );
};
